import { ApiResponse, BaseBodyResponse } from "api/api.d";
import { api } from "api/api";
import {
  AccountResponse,
  GetAllLoanAccountResponse,
  GetAllSavingResponse,
  GetCheckSourceAccountRes,
  GetCreditCardResponse,
  GetDebitCardsResponse,
} from "dto/dashboard/response/DashboardInfo.d";
import { UpdateAvatarRequest } from "@/dto/auth/request/auth-request";
import { get } from "lodash";
import { RESULT_CODE } from "@/constants/enum";

const BASE_URL = "/customer-service/rest/web/request";
export const dashboardAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentAccount: builder.query<
      ApiResponse<AccountResponse>,
      { pageNo: number; pageSize: number }
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "myAccountInquiry",
        data,
      }),
    }),
    getMyAccountInquiry: builder.mutation<
      ApiResponse<AccountResponse>,
      {
        keyword: string;
        branch: string;
        currencyUnit: string;
        status: string;
        pageNo: number;
        pageSize: number;
      }
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "myAccountInquiry",
        data,
      }),
    }),
    getAllSavings: builder.query<ApiResponse<GetAllSavingResponse>, void>({
      query: () => ({
        url: "/savings-service/rest/web/request",
        method: "POST",
        functionName: "getSavingsList",
      }),
    }),
    getLoanFromBankInquiry: builder.query<
      ApiResponse<GetAllLoanAccountResponse>,
      void
    >({
      query: () => ({
        url: BASE_URL,
        method: "POST",
        functionName: "loanFromBankInquiry",
      }),
    }),
    checkSourceAccountRes: builder.query<
      ApiResponse<GetCheckSourceAccountRes>,
      { sourceLinkId: string }
    >({
      query: ({ sourceLinkId }) => ({
        url: BASE_URL,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
        method: "POST",
        functionName: "checkSourceAccount",
        data: {
          sourceLinkId,
        },
      }),
    }),
    getinquiryCardList: builder.query<ApiResponse<GetCreditCardResponse>, void>(
      {
        query: () => ({
          url: BASE_URL,
          method: "POST",
          functionName: "inquiryCardList",
        }),
      },
    ),
    getDebitCards: builder.query<ApiResponse<GetDebitCardsResponse>, void>({
      query: () => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getDebitCards",
      }),
    }),
    updateAvatar: builder.mutation<
      ApiResponse<BaseBodyResponse>,
      UpdateAvatarRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "updateAvatar",
        data,
      }),
      invalidatesTags: (result) => {
        console.log({ result });
        const code = get(result, "body.resultCode", null);
        console.log({ code });
        return code === RESULT_CODE.SUCCESS
          ? [
              {
                type: "getUserProfile",
              },
            ]
          : [];
      },
    }),
    modifyAccAlias: builder.mutation<any, any>({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "modifyAccAlias",
        data,
      }),
    }),
    modifyAccPreference: builder.mutation<any, any>({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "modifyAccPreference",
        data,
      }),
    }),
    exportAccountTransactionHistory: builder.mutation<any, any>({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "exportAccountTransactionHistory",
        data,
      }),
    }),
    exportTransactionHistory: builder.mutation<any, any>({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "exportTransactionHistory",
        data,
      }),
    }),
    viewAccountStatement: builder.query<any, { accountNo: string }>({
      query: ({ accountNo }) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "viewAccountStatement",
        data: {
          accountNo,
        },
      }),
    }),
    exportMyAccountInquiry: builder.mutation<any, any>({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "exportMyAccountInquiry",
        data,
      }),
    }),
  }),
});

export const {
  useGetCurrentAccountQuery,
  useLazyGetCurrentAccountQuery,
  useGetAllSavingsQuery,
  useGetLoanFromBankInquiryQuery,
  useCheckSourceAccountResQuery,
  useLazyCheckSourceAccountResQuery,
  useGetinquiryCardListQuery,
  useGetDebitCardsQuery,
  useUpdateAvatarMutation,
  useModifyAccAliasMutation,
  useModifyAccPreferenceMutation,
  useGetMyAccountInquiryMutation,
  useExportAccountTransactionHistoryMutation,
  useExportTransactionHistoryMutation,
  useExportMyAccountInquiryMutation,
  useViewAccountStatementQuery,
} = dashboardAPI;
